import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import App from "./App"
// import { inDevelopMode } from "utils/env"
import store from "store"
import "./i18n/i18n"

//TODO : Uncomment this when GA is ready
// !inDevelopMode &&
//   Sentry.init({
//     dsn: "https://b4e7e5719d5f42d7bc2f936fd1855a81@o994084.ingest.sentry.io/4504474239500288",
//     integrations: [new BrowserTracing()],
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 1.0,
//   })

// Initialize app
const initializeApp = () => {
  try {
    const root = ReactDOM.createRoot(document.getElementById("root"))
    if (!root) {
      throw new Error("Root element not found")
    }

    root.render(
      <Provider store={store}>
        <App />
      </Provider>
    )
  } catch (error) {
    console.error("Error initializing app:", error)
  }
}

// Only proceed with app rendering if we're not redirecting
// if (!checkAndRedirectToDefaultLanguage()) {
initializeApp()
// }

//TODO : Uncomment this when GA is ready
// !inDevelopMode &&
//   ReactGA.initialize([
//     {
//       trackingId: process.env.REACT_APP_GA_MEASUREMENT_ID,
//       gaOptions: { debug_mode: true },
//       gtagOptions: { debug_mode: true },
//     },
//   ])

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
